import defineThemeMiddleware from '#shared/util/defineThemeMiddleware.js';

const { default: openInBrowser } = IS_CLIENT ? await import('#frontend/util/openInBrowser.js') : {};

/**
 * Handle external link element click events
 * @param {Event} event
 */
const openInBrowserClickHandler = function(event) {
	if (event.target.tagName === 'A' && event.target.target === '_blank') {
		event.preventDefault();
		openInBrowser(event.target.href);
	}
};

/**
 * Load handler which will open all _blank links in browser window (in-app) or default
 */
export default defineThemeMiddleware(() => {
	document.body.removeEventListener('click', openInBrowserClickHandler);
	document.body.addEventListener('click', openInBrowserClickHandler);
}, (context) => context.isClientProcess);
